
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("kblsY", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $89d9dbaf09195752$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Dutch (Netherlands)
var $89d9dbaf09195752$export$2e2bcd8739ae039 = {
    'fabric.emoji.add.custom.emoji.label': 'Voeg je eigen emoji toe',
    'fabric.emoji.add.label': 'Emoji toevoegen',
    'fabric.emoji.cancel.label': 'Annuleren',
    'fabric.emoji.categories.label': 'Kies een emoticoncategorie',
    'fabric.emoji.categories.search.results': 'Zoekresultaten',
    'fabric.emoji.category.activity': 'Activiteit',
    'fabric.emoji.category.all.uploads': 'Alle uploads',
    'fabric.emoji.category.flags': 'Vlaggen',
    'fabric.emoji.category.foods': 'Eten en drinken',
    'fabric.emoji.category.frequent': 'Vaak',
    'fabric.emoji.category.nature': 'Natuur',
    'fabric.emoji.category.objects': 'Objecten',
    'fabric.emoji.category.people': 'Mensen',
    'fabric.emoji.category.places': 'Reizen en plaatsen',
    'fabric.emoji.category.productivity': 'Productiviteit',
    'fabric.emoji.category.symbols': 'Symbolen',
    'fabric.emoji.category.user.uploads': 'Jouw uploads',
    'fabric.emoji.choose.file.screenReaderDescription': 'Kies een bestand voor de emoticon. Jpg, png of gif. Max. 1 MB.',
    'fabric.emoji.choose.file.title': 'Bestand kiezen',
    'fabric.emoji.delete.description': 'Alle bestaande exemplaren van deze emoji zullen vervangen worden door {emojiShortName}',
    'fabric.emoji.delete.label': 'Verwijderen',
    'fabric.emoji.delete.screenreader.tooltip': 'Druk op Backspace om de emoticon {shortName} te verwijderen',
    'fabric.emoji.delete.title': 'Emoji verwijderen',
    'fabric.emoji.delete.tooltip': 'Verwijderen',
    'fabric.emoji.emojipicker.emoi.roledescription': 'emoticon-knop',
    'fabric.emoji.emojipicker.error': 'Fout!',
    'fabric.emoji.error.delete.failed': 'Verwijderen mislukt',
    'fabric.emoji.error.image.too.big': 'De geselecteerde afbeelding is groter dan 1 MB',
    'fabric.emoji.error.invalid.image': 'Geselecteerde afbeelding is ongeldig',
    'fabric.emoji.error.upload.failed': 'Uploaden mislukt',
    'fabric.emoji.error.upload.timeout': 'Upload is verlopen',
    'fabric.emoji.image.requirements': 'JPG, PNG of GIF. Max. grootte 1 MB.',
    'fabric.emoji.name.ariaLabel': 'Voer een naam in voor de nieuwe emoji',
    'fabric.emoji.picker': 'Emoticon-kiezer',
    'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Zoekresultaten} other {Emoticons}}',
    'fabric.emoji.pickerlist.tabpanel': 'Emoticon-acties en lijstpaneel',
    'fabric.emoji.placeholder': 'Bijv. hallo',
    'fabric.emoji.preview': 'Je nieuwe emoji {emoji} ziet er goed uit',
    'fabric.emoji.preview.title': 'Voorvertoning',
    'fabric.emoji.retry.label': 'Opnieuw proberen',
    'fabric.emoji.search.label': 'Naam emoticon',
    'fabric.emoji.search.placeholder': 'Zoeken',
    'fabric.emoji.search.status': 'Alle emoticons worden getoond',
    'fabric.emoji.select.skin.list.ariaLabel': 'Huidskleur selecteren',
    'fabric.emoji.select.skin.tone.ariaLabel': 'Kies je huidskleur, {selectedTone} is geselecteerd'
};

});


//# sourceMappingURL=nl.8b019fcf.js.map
